import { Coordinate } from 'ol/coordinate';
import Map from 'ol/Map';
import Overlay, { Positioning } from 'ol/Overlay';

export class OlTooltip {

  private map: Map;
  private tooltipElement: HTMLElement;
  private overlay: Overlay;

  constructor(map: Map, id: string | HTMLElement, offset?: any[], positionning?: string) {
    this.map = map;
    this.tooltipElement = typeof id === 'string' ? document.getElementById(id) : id;
    this.overlay = new Overlay({
      element: this.tooltipElement,
      offset: (offset) ? offset : [0, -15],
      //   positioning: (positionning) ? positionning : 'bottom-center'
    });
  }

  activate() {
    this.map.addOverlay(this.overlay);
  }

  deactivate() {    
    this.map.removeOverlay(this.overlay);
  }

  setText(text: string) {
    if (this.tooltipElement) {
      this.tooltipElement.innerHTML = text;
    }
  }

  setPosition(position: Coordinate) {
    this.overlay.setPosition(position);
  }

  setPositioning(positioning: Positioning) {
    this.overlay.setPositioning(positioning);
  }

  setMap(map: Map) {
    this.map = map;
  }

  setOffset(offset: number[]) {
    this.overlay.setOffset(offset);
  }

  getText() {
    return this.tooltipElement ? this.tooltipElement.innerHTML : null;
  }

}